import styled from 'styled-components';

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const EditToggleButton = styled.button`
  background: none;
  border: 1px solid #0090d3;
  color: #0090d3;
  border-radius: 100px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
`;

export const SaveCancelBar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
`;

export const SmallOutlineButton = styled.button`
  background: #fff;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 8px 16px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SmallSolidButton = styled.button`
  background: #0090d3;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const EditedNotice = styled.div`
  font-size: 11px;
  color: #996b00;
  background: #fff7e6;
  border-radius: 6px;
  padding: 6px 10px;
  margin-bottom: 16px;
`;
